import axios from 'axios'
import { createApp } from 'vue'
import { getCookie } from '~/js/cookies'

const ID = 'js-articleContest'
const closeDateTime = new Date(2025, 2, 24).getTime() // 2025年3月23日まで投票可
const isClosed = closeDateTime < new Date().getTime()

document.addEventListener('DOMContentLoaded', async () => {
  const elementArticleContest = document.getElementById(ID)
  if (!elementArticleContest) return

  const { articleId, baseUrlFrontApi } = elementArticleContest.dataset

  let votedArticleId = null
  const userId = getCookie('_shopify_y')
  if (userId) {
    try {
      const { data } = await axios.get(
        `${baseUrlFrontApi}/mrc_contest/get_user_vote`,
        {
          params: { uid: userId },
        }
      )
      votedArticleId = data.articleId
    } catch (error) {
      console.error(error)
    }
  }
  createApp({
    name: 'TemplatesArticleContest',
    data() {
      return {
        votedArticleId,
        isProcessing: false,
      }
    },
    computed: {
      isButtonDisabled() {
        return this.votedArticleId || this.isProcessing || isClosed || undefined
      },
      buttonText() {
        if (isClosed) return '投票終了'
        if (this.votedArticleId) {
          return articleId == this.votedArticleId
            ? 'このコーディネートに投票済み'
            : '投票済み'
        }
        return '投票する'
      },
    },
    methods: {
      async onButtonVoteClicked(id) {
        if (this.isButtonDisabled) return
        if (!confirm('このコーディネートに投票します。よろしいですか？')) return
        this.isProcessing = true
        try {
          const { data } = await axios.post(
            `${baseUrlFrontApi}/mrc_contest/vote`,
            {
              userId,
              articleId: id.toString(),
            }
          )
          this.votedArticleId = data.articleId
        } catch (error) {
          console.error(error)
        }
        this.isProcessing = false
      },
    },
  }).mount(elementArticleContest)
})
